//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Storage from '@tencent/vft-common/Storage';
import { getUrlParam } from '@tencent/vft-common/util';
import env from '@tencent/vft-common/env';
import enableInlineVideo from 'iphone-inline-video';
var storageKey = 'huoshao_entry_video_flag';
export default {
  settingKey: '开屏视频',
  setting: {
    视频地址: 'https://m.film.qq.com/vip-activity/huoshao/static/huoshao.mp4',
    视频封面: ''
  },
  data: function data() {
    return {
      player: null,
      playing: false,
      support: true
    };
  },
  computed: {
    video: function video() {
      return this.$refs.video;
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 隐身模式 || 没有localstorage认为没有看过视频
    var hideVideo = +getUrlParam('hideVideo') === 1; // 推广位进入则不主动播放视频
    // const isAndroidWechat =
    //   (env.isWechat || window.WeiboJSBridge) && env.isAndroid // android微信无法自动播放

    this.checkVideo();

    if (this.support && !hideVideo && (Storage.safariPrivateMode || !Storage.get(storageKey))) {
      if (env.isIos) {
        enableInlineVideo(this.video);
      }

      this.video.addEventListener('ended', this.closeVideo);

      var removeControl = function removeControl() {
        // if (this.video.currentTime > 1) {
        _this.video.controls = false;
        _this.video.muted = false; // this.video.removeEventListener('playing', removeControl)
        // }
      };

      this.video.addEventListener('playing', removeControl);
      this.play();
    }
  },
  methods: {
    play: function play() {
      var _this2 = this;

      if (env.isWechat && env.isIos) {
        document.addEventListener('WeixinJSBridgeReady', function () {
          _this2.playing = true;

          _this2.video.play();

          window.aegis.infoAll('开屏视频：IOS微信环境播放');
        });
      } else if (window.WeiboJSBridge && env.isIos) {
        // 微博无法自动播放
        window.WeiboJSBridge.invoke('getNetworkType', {}, function () {
          _this2.playing = true;

          _this2.video.play();

          window.aegis.infoAll('开屏视频：微博环境播放');
        });
      } else {
        this.playing = true;
        this.video.play();
      }

      Storage.set(storageKey, new Date().getTime());
    },
    closeVideo: function closeVideo() {
      this.exitFullscreen();
      this.playing = false;
      this.video.pause();
      this.video.currentTime = 0;
    },
    checkVideo: function checkVideo() {
      if (document.createElement('video').canPlayType) {
        var vidTest = document.createElement('video');
        var h264Test = vidTest.canPlayType('video/mp4; codecs="avc1.42E01E"');

        if (!h264Test) {
          this.support = false;
        } else {
          this.support = true;
        }
      } else {
        this.support = false;
      }
    },
    exitFullscreen: function exitFullscreen() {
      var elem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

      if (elem.exitFullscreen) {
        elem.exitFullscreen();
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
      } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
      }
    }
  }
};